import type { SvgIconComponent } from '@mui/icons-material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import TuneIcon from '@mui/icons-material/Tune';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BrushIcon from '@mui/icons-material/Brush';
import RateReviewIcon from '@mui/icons-material/RateReview';
import CompressIcon from '@mui/icons-material/Compress';

import type { TextOperationType } from '../../../domain';

export interface TextOperationMeta {
  kind: TextOperationType;
  label: string;
  description: string;
  icon: SvgIconComponent;
  requiresDocument: boolean;
  /** Whether the op needs / can use a text selection. `'optional'` = uses it if present. */
  requiresSelection: boolean | 'optional';
}

export const TEXT_OPERATION_CATALOG: Record<TextOperationType, TextOperationMeta> = {
  Generate: {
    kind: 'Generate',
    label: 'Generate',
    description: 'Draft new prose from a prompt.',
    icon: AutoAwesomeIcon,
    requiresDocument: false,
    requiresSelection: false,
  },
  Continue: {
    kind: 'Continue',
    label: 'Continue',
    description: 'Extend the draft from where it leaves off.',
    icon: NavigateNextIcon,
    requiresDocument: true,
    requiresSelection: false,
  },
  Expand: {
    kind: 'Expand',
    label: 'Expand',
    description: 'Lengthen and enrich the current text.',
    icon: UnfoldMoreIcon,
    requiresDocument: true,
    requiresSelection: 'optional',
  },
  Refine: {
    kind: 'Refine',
    label: 'Refine',
    description: 'Polish wording and flow with optional direction.',
    icon: TuneIcon,
    requiresDocument: true,
    requiresSelection: 'optional',
  },
  Restructure: {
    kind: 'Restructure',
    label: 'Restructure',
    description: 'Reorganize the draft around a structure hint.',
    icon: AccountTreeIcon,
    requiresDocument: true,
    requiresSelection: false,
  },
  Stylize: {
    kind: 'Stylize',
    label: 'Stylize',
    description: 'Recast the text in a target voice/tone.',
    icon: BrushIcon,
    requiresDocument: true,
    requiresSelection: 'optional',
  },
  Critique: {
    kind: 'Critique',
    label: 'Critique',
    description: 'Get structured feedback without changing the draft.',
    icon: RateReviewIcon,
    requiresDocument: true,
    requiresSelection: 'optional',
  },
  Distill: {
    kind: 'Distill',
    label: 'Distill',
    description: 'Summarize the draft to a target length.',
    icon: CompressIcon,
    requiresDocument: true,
    requiresSelection: false,
  },
};

/** Display order for the operation dock. */
export const TEXT_OPERATION_ORDER: TextOperationType[] = [
  'Generate',
  'Continue',
  'Expand',
  'Refine',
  'Restructure',
  'Stylize',
  'Critique',
  'Distill',
];
